import { Property } from '@propertypal/shared/src/types/property';
import { PropertySearchResult } from '@propertypal/shared/src/types/propertySearch';

export const getPropertyPriceParam = (property?: Property) => {
  if (property?.price?.maxPrice && property?.price?.minPrice) {
    return [Math.round(property.price.minPrice / 10000) * 10, Math.round(property.price.maxPrice / 10000) * 10];
  }

  if (property?.price?.price) {
    if (property.saleType.key === 'rent') {
      return Math.floor(property.price.price / 100) * 100;
    }

    return Math.round(property.price.price / 10000) * 10;
  }

  return null;
};

export const getPropertyHeatingType = (property?: Property) => {
  const info = property?.keyInfo?.find((k) => k.key === 'HEATING_TYPE');

  return info?.text;
};

export const getHeatingParam = (result?: PropertySearchResult) => {
  const heatingTypes: string[] = [];

  result?.results.forEach((property) => {
    if (property.heatingType?.text && heatingTypes.indexOf(property.heatingType.text) === -1) {
      heatingTypes.push(property.heatingType.text);
    }
  });

  return heatingTypes;
};

export const getSearchPriceParam = (result?: PropertySearchResult) => {
  const divider = result?.params?.saleType && result.params.saleType[0] === 'rent' ? 1000 : 10000;
  const prices: number[] = [];

  result?.results.forEach((property) => {
    if (property.price?.price) {
      prices.push(Math.round(property.price.price / divider) * 10);
    }
  });

  return prices;
};
